import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import type { LabOrder } from './labOrdersSlice'

interface LabWorkState {
  orders: LabOrder[]
  loading: boolean
  error: string | null
}

const initialState: LabWorkState = {
  orders: [],
  loading: false,
  error: null,
}

export const fetchLabOrders = createAsyncThunk('labWork/fetchAll', async () => {
  const res = await fetch('/.netlify/functions/lab-orders')
  if (!res.ok) throw new Error('Failed to fetch lab orders')
  return res.json() as Promise<LabOrder[]>
})

export const createLabOrder = createAsyncThunk(
  'labWork/create',
  async (data: {
    patient_id: string
    test_name: string
    veterinarian_id: string
    priority: string
    notes: string
  }) => {
    const res = await fetch('/.netlify/functions/lab-orders', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    if (!res.ok) throw new Error('Failed to create lab order')
    return res.json() as Promise<LabOrder>
  }
)

const labWorkSlice = createSlice({
  name: 'labWork',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLabOrders.pending, (state) => {
        if (state.orders.length === 0) state.loading = true
      })
      .addCase(fetchLabOrders.fulfilled, (state, action) => {
        state.orders = action.payload
        state.loading = false
        state.error = null
      })
      .addCase(fetchLabOrders.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to load'
      })
      .addCase(createLabOrder.fulfilled, (state, action) => {
        state.orders.unshift(action.payload)
      })
  },
})

export default labWorkSlice.reducer
